import keyMirror from 'keymirror';

export const states = keyMirror({
    HOME: true,
    DATI_SEGNALAZIONE_E_ANAGRAFICI: true,
    DATI_SANITARI: true,
    INFO_CLINICHE: true,
    ESITO: true,
    DATI_SPECIFICI: true,
    SCHEDA_SPECIALE: true,
    SCHEDA_SPECIALE_ESITO_TBC: true,
    CONFIRM: true
});
